(function () {
  function initSwiper(swiperEl) {
    if (!swiperEl || typeof Swiper === 'undefined') return null;
    if (swiperEl.swiper) return swiperEl.swiper;

    var swiperConfig = {
      slidesPerView: 'auto',
      spaceBetween: 16,
      grabCursor: true,
      scrollbar: {
        el: swiperEl.querySelector('.swiper-scrollbar'),
        draggable: true,
        hide: false,
      },
      mousewheel: {
        forceToAxis: true,
        sensitivity: 1,
      },
      breakpoints: {
        750: {
          slidesPerView: 4,
          spaceBetween: 40,
        },
      },
    };

    return new Swiper(swiperEl, swiperConfig);
  }

  function initAllSwipers() {
    document.querySelectorAll('.ctr-ingredients__carousel').forEach(function (swiperEl) {
      initSwiper(swiperEl);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSwipers);
  } else {
    initAllSwipers();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var swiperEl = e.target.querySelector('.ctr-ingredients__carousel');
    if (swiperEl) initSwiper(swiperEl);
  });
})();
